let didInit = false;

export function initTagManager(containerId) {
  const id = String(containerId || "").trim();
  if (!id || didInit) return;
  didInit = true;

  // Avoid injecting twice if already present (e.g. hot reload)
  if (document.getElementById("gtm-script")) return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    "gtm.start": new Date().getTime(),
    event: "gtm.js",
  });

  const script = document.createElement("script");
  script.id = "gtm-script";
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${encodeURIComponent(
    id
  )}`;
  document.head.appendChild(script);

  // Optional noscript fallback (harmless even for SPA)
  if (!document.getElementById("gtm-noscript")) {
    const iframe = document.createElement("iframe");
    iframe.id = "gtm-noscript";
    iframe.src = `https://www.googletagmanager.com/ns.html?id=${encodeURIComponent(
      id
    )}`;
    iframe.height = "0";
    iframe.width = "0";
    iframe.style.display = "none";
    iframe.style.visibility = "hidden";
    document.body.appendChild(iframe);
  }
}

